import script from "./DesignView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DesignView.vue?vue&type=script&lang=ts&setup=true"

import "./DesignView.vue?vue&type=style&index=0&id=2f997e0f&lang=scss"

const __exports__ = script;

export default __exports__